export const TEST_ID = 'chemicalDetailPage';

export const CARD_HEADER_DETAIL_TYPE = 'chemical';
